import React, { useContext } from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import { colors } from 'utils/colors'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import AppbarLogo from 'assets/applogo.png'
import { EventContext, SessionContext } from 'context'
import Box from '@material-ui/core/Box'
import { useSelector } from 'react-redux'
import { getDefaultTimezone } from 'utils/times'
import { useDispatch } from 'react-redux'
import talkSlice from 'store/talk'
import pollingSlice from 'store/polling'

const ModeratorTopBar = () => {
  const dispatch = useDispatch()
  const { logout } = useContext(EventContext)
  const { logoutSession } = useContext(SessionContext)
  const history = useHistory()
  const classes = useStyles()
  const { conference } = useSelector((state) => state.conference)

  const defaultTimezone = getDefaultTimezone(conference?.timezone)

  const logoutModerator = () => {
    logout()
    logoutSession()
    dispatch(talkSlice.actions.setTalks([]))
    dispatch(pollingSlice.actions.setPollAssociatedData(null))
    history.push('/poll')
  }

  return (
    <AppBar
      position="fixed"
      className={classes.appBar}
      style={{
        background: process.env.REACT_APP_NODE_ENV === 'development' ? '#FF8080' : colors.indigo
      }}>
      <Toolbar className={classes.toolbar}>
        <img className={classes.logo} alt="Remy Sharp" src={AppbarLogo} />
        <Typography variant="h5" className={classes.heading}>
          Moderator Panel
        </Typography>
        <Button
          variant="contained"
          size="medium"
          className={classes.logoutBtn}
          onClick={logoutModerator}>
          Logout
        </Button>
      </Toolbar>
      <Box className={classes.extraBar}>
        All times are in {conference?.timezone ?? defaultTimezone} Time Zone.
      </Box>
    </AppBar>
  )
}

export default ModeratorTopBar

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.default
  },
  toolbar: {
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: 5,
    marginBottom: 5
  },
  logo: {
    height: 50,
    width: 120,
    cursor: 'pointer'
  },
  heading: {
    fontWeight: 'bold',
    margin: 'auto',
    color: colors.white
  },
  extraBar: {
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#FEE01C',
    color: '#000000',
    fontWeight: 'bold',
    padding: '4px'
  },
  logoutBtn: {
    color: 'white',
    fontWeight: 'bold',
    background: 'transparent',
    cursor: 'pointer',
    border: '1px solid white',
    marginRight: '3rem',
    '&:hover': {
      background: 'transparent'
    }
  }
}))
